import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FaExclamation } from "react-icons/fa";

const OnDemandConsoleModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleEscapeKey = useCallback(
    (event) => {
      if (event.key === "Escape") {
        onClose();
        navigate("#");
      }
    },
    [onClose, navigate],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [handleEscapeKey]);

  const handleNavigateToAssignment = () => {
    navigate("/assignments?open=true&user=me");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 p-6 rounded-lg shadow-xl max-w-lg w-full">
        <div className="flex items-center mb-4">
          <FaExclamation className="mr-1 text-red-400" />
          <h3 className="text-xl font-bold">Open Conversation</h3>
        </div>
        <div className="mt-1 relative rounded-md shadow-sm">
          <h4>Click "Go to Assignments" to view your open conversations.</h4>
          <div className="mt-2 opacity-50">
            If you still encounter this error after closing your assignments,
            please contact an administrator. There may be an assignment open for
            the phone number you are attempting to contact.
          </div>
        </div>
        <div className="flex justify-end space-x-4 mt-5">
          <button
            onClick={() => onClose()}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
          <button
            onClick={() => handleNavigateToAssignment()}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Go to Assignments
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnDemandConsoleModal;
